<template>
  <div class="mypage notranslate">
    <div class="mb30">
      <h1 class="boxTitle mb15 toCapitalize">{{locale.mypage}}</h1>
      <!-- <div v-if="mypage && (mypage.room || mypage.checkin || mypage.checkout)" class="info">
        <div v-if="mypage && mypage.room" class="room">{{space}}</div>
        <div v-if="mypage && mypage.checkin" class="period"><span class="label">CHECK-IN</span><span class="colorGrey">{{dateFormatWidthTz(stayAfter)}}</span></div>
        <div v-if="mypage && mypage.checkout" class="period"><span class="label">CHECK-OUT</span><span class="colorGrey">{{dateFormatWidthTz(stayBefore)}}</span></div>
      </div> -->
      <div class="list toCapitalize">
        <router-link v-if="mypage ? mypage.coupon : true" :to="{name: 'coupon'}" class="item myCoupon horizontal">
          {{locale.coupon}}
          <i class="cnt" :data-cnt="coupon" :style="coupon > 0 && { ...skinStyle('countBg', 'background-color'), ...skinStyle('countText', 'color') }">{{coupon}}</i>
        </router-link>
        <router-link v-if="mypage ? mypage.cart : true" :to="{name: 'cart'}" class="item myCart horizontal">
          {{locale.cart}}
          <i class="cnt" :data-cnt="cart" :style="cart > 0 && { ...skinStyle('countBg', 'background-color'), ...skinStyle('countText', 'color') }">{{cart}}</i>
        </router-link>
        <router-link v-if="mypage ? mypage.order : true" :to="{name: 'myOrder'}" class="item myOrder">
          {{locale.order_list}}
          <i class="cnt" :data-cnt="order" :style="order > 0 && { ...skinStyle('countBg', 'background-color'), ...skinStyle('countText', 'color') }">{{order}}</i>
        </router-link>
        <router-link v-if="mypage ? mypage.payment : true" :to="{name: 'myPayment'}" class="item myPayment">
          {{locale.payment_list}}
          <i class="cnt" :data-cnt="payment" :style="payment > 0 && { ...skinStyle('countBg', 'background-color'), ...skinStyle('countText', 'color') }">{{payment}}</i>
        </router-link>
        <router-link v-if="mypage ? mypage.reservation : true" :to="{name: 'myReservation'}" class="item myReservation">
          {{locale.reservation_list}}
          <i class="cnt" :data-cnt="reservation" :style="reservation > 0 && { ...skinStyle('countBg', 'background-color'), ...skinStyle('countText', 'color') }">{{reservation}}</i>
        </router-link>
        <router-link v-if="mypage ? mypage.mobility : true" :to="{name: 'myMobility'}" class="item myMobility">
          {{locale.mobility_my}}
        </router-link>
        <!-- <router-link :to="{name: 'checkout'}" class="myCheckout btn btnFull">{{locale.self_checkout}}</router-link> -->
      </div>
    </div>
    <!-- <h2 class="boxTitle mb15">{{locale.service_shortcut}}</h2>
    <div class="shortcut">
      <router-link :to="{name: 'amenity'}" class="item myAmenity">{{locale.amenity}}</router-link>
      <router-link :to="{name: 'tv'}" class="item myChannelGuide">{{locale.channel_guide}}</router-link>
      <router-link :to="{name: 'localinfo'}" class="item myLocalinfo">{{locale.localinfo}}</router-link>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'

export default {
  name: 'Mypage',
  props: [
    'lang',
    'locale',
    'roomKey',
    'isPublic'
  ],
  components: {
  },
  computed: {
    ...mapGetters({
      cartList: 'cart/getList',
      getMetaInfo: 'authentication/getMetaInfo'
    }),
    setting () {
      return this.$store.state.common.setting
    },
    mypage () {
      return this.setting && this.setting.mypage
    },
    dateFormat () {
      const setting = this.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      return date
    },
    format () {
      const time = 'HH:mm:ss'
      return `${this.dateFormat} ${time}`
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    couponKey () {
      const hasOid = !!this.oid && this.oid !== 'undefined' && this.oid !== 'na'
      const key = this.roomKey !== null ? `spaceid=${this.space}&k=${this.key}` : hasOid ? `oid=${this.oid}` : null
      return key
    },
    cart () {
      return this.cartList.length
    },
    space () {
      const space = this.$store.state.authentication.space
      return space && space !== 'undefined' ? space : '-'
    },
    pointColors () {
      return this.$store.getters['common/getPointColors']
    }
  },
  async mounted () {
    // 주문내역에서 제외할 전송코드
    const notInclude = /reservation|morningcall|parking|mobility|tip/
    await this.getKey()
    this.$store.dispatch('submit/getOrderHistory').then((res) => {
      this.order = res.orderLog.filter(x => !notInclude.test(x.order_type)).length || 0
      this.payment = res.paidLog.length || 0
      this.reservation = res.orderLog.filter(x => {
        return x.order_type && x.order_type.includes('reservation')
      }).length || 0
    })
    if (this.couponKey) {
      this.$store.dispatch('coupon/getCoupon', this.couponKey).then((res) => {
        this.coupon = res.length || 0
      })
    }
  },
  data () {
    return {
      coupon: 0,
      order: 0,
      payment: 0,
      reservation: 0,
      stayAfter: '-',
      stayBefore: '-',
      key: this.$store.state.authentication ? this.$store.state.authentication.k : null,
      oid: this.$store.state.authentication ? this.$store.state.authentication.oid : null
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'mypage'
      })
    },
    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    },
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
    },
    init () {
      this.track()
    },
    dateFormatWidthTz (iso) {
      const tzDateTime = DateTime.fromISO(iso, { zone: this.timezone })
      return iso === '-' ? '-' : tzDateTime.toFormat(this.format)
    }
  }
}
</script>

<style lang="scss" scoped>
.info {
  margin-bottom: 15px;
  padding: 30px;
  border-radius: 4px;
  border: 1px solid $color-lgrey2;
  background: linear-gradient(135deg, $color-white 30%, $bg-default);
  .room {
    font-size: 2em;
    font-weight: 700;
    & + .period {
      margin-top: 30px;
    }
  }
  .period {
    display: flex;
    align-items: center;
    .label {
      width: 108px;
      margin-right: 10px;
      padding: 5px 0 5px 15px;
      font-size: 0.85em;
      border-radius: 50px;
      border: 1px solid $color-lgrey2;
      background-color: $color-lgrey2;
      background: linear-gradient(135deg, $bg-default, $color-lgrey2);
    }
    & + .period {
      margin-top: 5px;
    }
  }
}
.list {
  .item {
    display: flex;
    align-items: center;
    position: relative;
    padding: 15px 10px 15px 30px;
    text-align: center;
    word-break: keep-all;
    border: 1px solid $color-lgrey2;
    border-radius: 4px;
    background: linear-gradient(135deg, $color-white 50%, $bg-default);
    & + .item {
      margin-top: 5px;
    }
    &:before {
      content: "";
      display: block;
      width: 24px;
      height: 24px;
      margin-right: 15px;
      background-size: contain;
      background-position: 50% 50%;
      background-repeat: no-repeat;
      opacity: 0.8;
    }
    &.myCart:before {
      background-image: url('~@/assets/img/ico_mypage_cart.png');
    }
    &.myOrder:before {
      background-image: url('~@/assets/img/ico_mypage_order.png');
    }
    &.myPayment:before {
      background-image: url('~@/assets/img/ico_mypage_payment.png');
    }
    &.myReservation:before {
      background-image: url('~@/assets/img/ico_mypage_reservation.png');
    }
    &.myCoupon:before {
      background-image: url('~@/assets/img/ico_mypage_coupon.png');
    }
    &.myMobility:before {
      background-image: url('~@/assets/img/ico_mypage_mobility.png');
    }
    .cnt {
      position: absolute;
      top: 50%;
      right: 10px;
      min-width: 20px;
      height: 20px;
      margin-top: -10px;
      padding-left: 5px;
      padding-right: 5px;
      text-align: center;
      font-size: 12px;
      font-weight: 700;
      line-height: 20px;
      border-radius: 30px;
      white-space: nowrap;
      color: $color-white;
      background-color: $color-primary;
      &[data-cnt="0"] {
        background-color: $color-lgrey;
      }
    }
  }
  .myCheckout {
    flex: none;
    margin-top: 15px;
    border-radius: 4px;
    &:before {
      display: none;
    }
  }
}
.shortcut {
  border-top: 1px solid $color-lgrey2;
  .item {
    display: flex;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid $color-lgrey2;
    &:before {
      content: "";
      width: 32px;
      height: 32px;
      margin-right: 8px;
      background-size: contain;
      background-position: 50% 50%;
      background-repeat: no-repeat;
    }
    &.myAmenity:before {
      background-image: url('~@/assets/img/ico_amenity.png');
    }
    &.myChannelGuide:before {
      background-image: url('~@/assets/img/ico_tv.png');
    }
    &.myLocalinfo:before {
      background-image: url('~@/assets/img/ico_localinfo.png');
    }
  }
}
@media screen and (min-width: 768px) {
  .list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 4px;
    column-gap: 4px;
    overflow: hidden;
    border-radius: 4px;
    .item {
      display: block;
      padding: 60px 0 40px;
      & + .item {
        margin-top: 0;
      }
      &:before {
        width: 32px;
        height: 32px;
        margin: 0 auto 15px;
      }
      .cnt {
        top: 10px;
        min-width: 30px;
        height: 30px;
        margin-top: 0;
        font-size: 14px;
        line-height: 30px;
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .list {
    grid-template-columns: repeat(5, 1fr);
  }
}
</style>
